
/* PROMOCODE */
export const GET_PROMOCODE_LISTING = "GET_PROMOCODE_LISTING";
export const GET_PROMOCODE_LISTING_SUCCESS = "GET_PROMOCODE_LISTING_SUCCESS";
export const GET_PROMOCODE_LISTING_FAIL = "GET_PROMOCODE_LISTING_FAIL";

export const GET_PROMOCODE_DETAILS = "GET_PROMOCODE_DETAILS";
export const GET_PROMOCODE_DETAILS_SUCCESS = "GET_PROMOCODE_DETAILS_SUCCESS";
export const GET_PROMOCODE_DETAILS_FAIL = "GET_PROMOCODE_DETAILS_FAIL";

export const ADD_PROMOCODE = "ADD_PROMOCODE";
export const ADD_PROMOCODE_SUCCESS = "ADD_PROMOCODE_SUCCESS";
export const ADD_PROMOCODE_FAIL = "ADD_PROMOCODE_FAIL";

export const UPDATE_PROMOCODE = "UPDATE_PROMOCODE";
export const UPDATE_PROMOCODE_SUCCESS = "UPDATE_PROMOCODE_SUCCESS";
export const UPDATE_PROMOCODE_FAIL = "UPDATE_PROMOCODE_FAIL";

export const DELETE_PROMOCODE = "DELETE_PROMOCODE";
export const DELETE_PROMOCODE_SUCCESS = "DELETE_PROMOCODE_SUCCESS";
export const DELETE_PROMOCODE_FAIL = "DELETE_PROMOCODE_FAIL";

export const EXPORT_PROMOCODE = "EXPORT_PROMOCODE";
export const EXPORT_PROMOCODE_SUCCESS = "EXPORT_PROMOCODE_SUCCESS";
export const EXPORT_PROMOCODE_FAIL = "EXPORT_PROMOCODE_FAIL";

export const RESET_PROMOCODE_STATE = 'RESET_PROMOCODE_STATE';
export const RESET_PROMOCODE_ATTACHMENT_STATE = 'RESET_PROMOCODE_ATTACHMENT_STATE';